import React from "react";
import "./style.scss";

import { AuthForm } from "./components/AuthForm";

import { useTranslation } from 'react-i18next';

import ReactFlagsSelect from 'react-flags-select';

const TestLoginDefault = () => {

  const { i18n } = useTranslation();

  const lang = localStorage.getItem("selectedLanguage");

  if (!lang) {
    localStorage.setItem("selectedLanguage", "US");
    i18n.changeLanguage("US");
  }

  const handleChangeLanguage = (code) => {
    i18n.changeLanguage(code);
    localStorage.setItem("selectedLanguage", code);
  }

  return (
    <div className="test-login-container">
      <ReactFlagsSelect
        className="language-dropdown"
        selected={lang}
        onSelect={handleChangeLanguage}
        countries={["US", "ES"]}
        customLabels={{"US": "ENG","ES": "ESP"}}
        placeholder="Select"
      />
      <div className="login-block">
        <AuthForm />
      </div>
    </div>
  )
}

export default TestLoginDefault;